module.exports = __webpack_public_path__ + "img/gyl-new-bg1.c864e203.png";